import { createContext } from "react";

export interface TourData {
  disableNextBtn: boolean;
  hideBackBtn: boolean;
}

const GuideTourContext = createContext<TourData | undefined>(undefined);

export default GuideTourContext;
